import { render, staticRenderFns } from "./budgetPreparationAdjustDetail.vue?vue&type=template&id=0927346d&scoped=true&"
import script from "./budgetPreparationAdjustDetail.vue?vue&type=script&lang=js&"
export * from "./budgetPreparationAdjustDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0927346d",
  null
  
)

export default component.exports